import React from 'react';
import ReactTable from 'react-table-v6'
import { toast, } from 'react-toastify';
import Button from '@material-ui/core/Button';
import '../../assets/css/Order.css'
import axios from 'axios'
import {NavLink} from "react-router-dom";
import { withStyles } from '@material-ui/core/styles';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid'
import Card from "../Card/Card.jsx";
import { BASE_URL } from '../../utils/handleApi';

const useStyles = (theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
            marginBottom: theme.spacing(5)
        }
    },
    rootButton: {
        '& > *': {
            margin: theme.spacing(1),
            marginTop: theme.spacing(-1.8),
            marginLeft: theme.spacing(1.5)
        }
    },
    paper: {
        backgroundColor: "red"
    },
    margin: {
        // margin: theme.spacing(1),
        marginRight: theme.spacing(10)
    },
    withoutLabel: {
        marginTop: theme.spacing(2),
    },
    textField: {
        width: '16vw',
    },

});

const toTitleCase = (phrase) => {
    return phrase
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
};
class Detailstable extends React.Component {
    
    state = {
        persons: [],
        accountInfo: []
    }

    componentDidMount() {
        const tokenStr = localStorage.getItem('token')
        axios.get(`${BASE_URL}/vendor/myAccount`,{
            headers: {
              'Authorization': `Bearer ${tokenStr}`
            }
          })
        .then(res => {
            this.setState({ persons: res.data.vendor });
        })
        .catch(() => {
            toast.error('Some error happened!')
        })

        axios.post(`${BASE_URL}/vendor/accountInfo`,{} ,{
            headers: {
              'Authorization': `Bearer ${tokenStr}`
            }
        })
        .then(res => {
            this.setState({ accountInfo: res.data });
        })
        .catch(() => {
            toast.error('Some error happened!')
        })
    }
      
    render() {
        const { classes } = this.props;
        const { persons, accountInfo } = this.state;
        const data1 = Object.entries(persons).map((person, i) => ({
            key: (<span>{toTitleCase(person[0])}</span>),
            value: <span>{person[1]}</span>
        }))

        const data2 = Object.entries(accountInfo).map((data, i) => ({
            key: (<span>{toTitleCase(data[0])}</span>),
            value: <span>{data[1]}</span>
        }))
        
        return (
            <div style={{ width: '85vw', marginLeft: 'auto', marginRight: 'auto', backgroundColor: 'white' }}>
                <Grid container spacing={3} justify="center" >
                    <Grid item xs={12} md={6}  >
                    <div style={{width:'95%'}}>
                            <Card style={{ boxShadow: '0px 0px 5px 0px #d6d6d6'  }}>
                                <div className={classes.rootButton}>
                                    <Button variant="contained" style={{ boxShadow: '0px 3px 5px -2px #AAAAAA',outline: 'none', color: 'white', height: '50px', width: '170px', fontFamily: 'Roboto-Bold', backgroundColor: '#04AB23', textTransform: 'none' }} disabled>
                                    Account Details
                                    </Button>
                                </div>
                                <CardContent>
                                    <ReactTable
                                        data={[...data1, ...data2.slice(0,1)]}
                                        columns={[
                                            {
                                                accessor: 'key',
                                                headerStyle: { border: 'none' },
                                                style: { border: 'none', color: '#AAAAAA', fontFamily: "Roboto-Bold" },
                                                width: 200
                                            },
                                            {
                                                accessor: 'value',
                                                headerStyle: { border: 'none' },
                                                style: { fontFamily: 'Roboto-Regular', color: '#888888', fontWeight: 'bolder' }
                                            },

                                        ]}
                                        showPaginationBottom={false}
                                        defaultPageSize={9}
                                        sortable={false}
                                        style={{ border: 'none', marginLeft: '2em', }}
                                        getTrGroupProps={() => {
                                            return {
                                                style: {
                                                    border: "0px",
                                                    backgroundColor: 'white'
                                                }
                                            }
                                        }}
                                        
                                    />
                                     <div className={classes.root} style={{textAlign: "center"}}>
                                <NavLink to="/Editvendor">          
                                <Button
                                    variant="contained"
                                    style={{ fontSize: '21px', fontFamily: 'Roboto-Regular', borderRadius: 0, 
                                    outline: 'none', color: 'white', backgroundColor: 'rgb(4, 171, 35)', height: '50px', 
                                    width: '10rem', textTransform: 'none', }}
                                >
                                    Edit
                                </Button>
                                </NavLink>
                            </div>
                                </CardContent>
                            </Card>
                        </div>
                    </Grid>
                </Grid>

            </div>
        )
    }
}
export default withStyles(useStyles, { withTheme: true })(Detailstable)
